import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useContext,
} from "react";
import EditBodySidebar from "./EditBodySidebar";
import EditBodyInput from "./EditBodyInput";
import style from "../../style/ReferralEditBody.module.scss";
import { useQuery } from "react-query";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Logger from "../../libraries/Logger";
import apiClient from "../../libraries/ApiClient";

import { NoticeDataContext } from "../../contexts/NoticeDataContext";

import apiOtherClient from "../../libraries/ApiOtherClient";

function ReferralEditBody({
  setDataFromBody,
  setSendBasicData,
  setSendOperativeData,
  setSendMediaData,
  setSendPreoperativeMediaData,
  setSendPostoperativeMediaData,
  setSendPdfData,
  setDetailData,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [rowId, setRowId] = useState("");
  const [token, setToken] = useState("");
  const { nData, setNData, refreshNData, setRefreshNData } =
    useContext(NoticeDataContext);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setRowId(params.get("rowId"));
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
  }, []);

  const getReferralDetail = async ({ queryKey }) => {
    const [_, rowId, token] = queryKey;
    const data = {
      Data: {
        RowId: rowId,
      },
    };
    const res = await apiClient.postAes("api/referral/Detail/Security", data);
    if (res?.status === 401) {
      alert("您的授權已失效，請重新登入");
      navigate("/Login");
      return null;
    }

    return res?.data;
  };
  const getReferralStatus = async ({ queryKey }) => {
    const [_, rowId, token] = queryKey;
    const data = {
      Data: {
        RowId: rowId,
      },
    };

    const res = await apiClient.postAes("api/referral/Detail/Security", data);
    if (res?.status === 401) {
      alert("您的授權已失效，請重新登入");
      navigate("/Login");
      return null;
    }

    return res?.data;
  };

  const { data, isLoading } = useQuery(
    ["getReferralDetail", rowId, token],
    getReferralDetail,
    {
      enabled: !!token,
      refetchOnWindowFocus: false,
      cacheTime: 0,
    }
  );
  const { data: ReferralData } = useQuery(
    ["getReferralStatus", rowId, token],
    getReferralStatus,
    {
      enabled: !!token,
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    setDataFromBody({
      Name: data?.Data?.Name,
      Sex: data?.Data?.Sex,
      IdNo: data?.Data?.IdNo,
      RowId: data?.Data?.RowId,
      PostoperativeRowId: data?.Data?.PostoperativeParameters?.RowId,
      CaseCode: data?.Data?.CaseCode,
      Code: data?.Code,
    });
    setDetailData(data);
    setRefreshNData(0);
  }, [data]);

  //console.log(data);
  return (
    <div className={style.container}>
      <EditBodySidebar
        progressData={ReferralData?.Data?.ReferralStatus}
        CaseStatus={ReferralData?.Data?.CaseStatus}
        PatientStatus={ReferralData?.Data?.PatientStatus}
        hospital={data?.Data?.OrgName}
        caseCode={data?.Data?.CaseCode}
        rowId={rowId}
        referralFeedback={data?.Data?.ReferralFeedback}
        caseStatusCode={data?.Data?.CaseStatus?.Code}
        patientStatusCode={data?.Data?.PatientStatus?.Code}
      />
      <EditBodyInput
        inputData={data?.Data}
        setSendBasicData={setSendBasicData}
        setSendOperativeData={setSendOperativeData}
        setSendMediaData={setSendMediaData}
        setSendPreoperativeMediaData={setSendPreoperativeMediaData}
        setSendPostoperativeMediaData={setSendPostoperativeMediaData}
        setSendPdfData={setSendPdfData}
        caseStatusCode={data?.Data?.CaseStatus?.Code}
        patientStatusCode={data?.Data?.PatientStatus?.Code}
      />
     
    </div>
  );
}

export default ReferralEditBody;
